import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="22f3erh9dfjom">
      <div className="mx-auto max-w-5xl px-4" data-id="element-21" data-mp="1yf32o39qvkkq">
        <div className="text-center" data-id="element-22" data-mp="1yc736ai90nu6">
          <GiftIcon className="mx-auto h-10 w-10 text-gold" data-id="element-23" data-mp="1annvnx70wf35" />
          <p className="mt-4 text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-24" data-mp="1am2x7whl8c00">Siempre incluidos · siempre gratis</p>
          <h2 id="bonus-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-25" data-mp="1jhaobefxp284">Los {totalBonuses} bonos estratégicos</h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-26" data-mp="1eorb4il5s93u">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.article key={bonus.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className={`card-space flex flex-col rounded-2xl p-6 text-onDark shadow-card ${bonus.wide ? 'border-2 border-gold md:col-span-2' : 'border border-gold/25'}`} data-id="element-27" data-mp="mxtitfmpeqiw" data-mpi={index}>
                <span className="mb-5 flex h-10 w-10 items-center justify-center rounded-lg border border-gold/30 bg-petrolDark text-gold" data-id="element-28" data-mp="1qus4dxakl1xb">
                  <Icon className="h-5 w-5" data-id="element-29" data-mp="20reqepemtz0x" />
                </span>
                <p className="text-[10px] font-extrabold uppercase tracking-wider text-gold" data-id="element-30" data-mp="20q3mmpl6sr9t">Bono {bonus.number}</p>
                <h3 className="mt-2 text-xl font-bold text-white" data-id="element-31" data-mp="25o53r4z1ygin">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-mutedDark" data-id="element-32" data-mp="3c8o56ymtg2vw">{bonus.description}</p>

                {bonus.items && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-33" data-mp="1h35a3uzy8pws">
                    {bonus.items.map(item => <li key={item} className="rounded-full border border-lineDark bg-petrolDark px-3 py-1 text-xs font-semibold text-mutedDark" data-id="element-34" data-mp="1c4u2lqx4mrhq">
                        {item}
                      </li>)}
                  </ul>}

                {bonus.purpose && <p className="panel-dark mt-4 flex-1 rounded-xl border border-gold/25 px-4 py-3 text-sm text-onDark" data-id="element-35" data-mp="yc4e9fu4lahg">
                    Su función es <b className="font-extrabold uppercase tracking-wide text-gold" data-id="element-36" data-mp="tfnpcjf3qs3b">{bonus.purpose}</b>
                  </p>}

                <p className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-lineDark pt-4 text-sm" data-id="element-37" data-mp="12er9lqq09dje">
                  <span className="text-mutedDark line-through" data-id="element-38" data-mp="env9857hha0j">Valor {bonus.value}</span>
                  <span className="rounded-full bg-gold px-3 py-1 text-xs font-extrabold text-petrolDark" data-id="element-39" data-mp="ao4n4eswji2c">GRATIS</span>
                </p>
              </motion.article>;
        })}
        </div>

        <div className="bg-stage-deep starfield mt-8 flex flex-col items-center justify-between gap-4 rounded-2xl border border-gold/40 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-40" data-mp="5ad31cy4xk3h">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-41" data-mp="3rp65ussiaydj">Total de bonos</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-42" data-mp="j9mfq2n4tw2p">
            {totalBonuses} bonos exclusivos
          </p>
        </div>

        <p className="mx-auto mt-6 max-w-xl rounded-xl border border-gold/30 bg-goldSoft px-5 py-4 text-center text-sm text-alert" data-id="element-43" data-mp="o6wa7wpdoxxe">
          Valor total de los {totalBonuses} bonos <span className="mx-1 text-muted line-through" data-id="element-44" data-mp="e984kbq8i60g">{bonusTotalValue}</span>
          <b className="font-extrabold" data-id="element-45" data-mp="2u0vzy2plnqh5">→ GRATIS con tu Megapack</b>
        </p>
      </div>
    </section>;
}